import React from "react";
import { useNavigate } from "react-router-dom";

import SubjectForm from "./components/SubjectForm/SubjectForm";

import Button from "../../components/Button/Button";
import http from "../../utils/http";
import toast from "../../utils/toast";

import "./AddSubject.scss";

export default function AddSubject() {
  const navigate = useNavigate();

  const handleClickSubmit = data => {
    if (!data?.thumbnail?.length) {
      delete data.thumbnail;
    } else {
      data.thumbnail = data?.thumbnail[0];
    }
    http
      .POST_FILE("school/subject/create/", data)
      .then(res => {
        toast.success("School Added Successfully!");
        setTimeout(() => {
          navigate("../");
        }, 1000);
      })
      .catch(error => {
        toast.error(error);
      });
  };

  return (
    <>
      <div className="page_header">
        <h4 className="page_title">Subjects | Add Subject</h4>

        <div className="button_wrapper ">
          <Button
            type="button"
            buttonName="< Back"
            color="success"
            clickHandler={() => navigate("../")}
          />
        </div>
      </div>

      <div className="add_subject_form">
        <SubjectForm
          editform={false}
          handleClickSubmit={data => handleClickSubmit(data)}
        />
      </div>
    </>
  );
}
